import { Immutable } from "immer";
import React from "react";
import { CompleteDeferredPayment } from "tsi-common-react/src/apps/checkout/CompleteDeferredPayment/index";
import { FinancingUpsellBlock } from "tsi-common-react/src/apps/checkout/FinancingUpsellBlock/index";
import { registerCheckoutCascades } from "tsi-common-react/src/apps/checkout/cascades-checkout";
import { strToBool } from "tsi-common-react/src/utils/format";
import { getPageSetting } from "tsi-common-react/src/utils/settings";

import { store } from "../../store";

// Checkout-specific store cascades, registered once when this client-only
// module loads -- before the CompleteDeferredPayment component first renders,
// mirroring the original placement inside the app mount. Loaded only on the
// client (via DeferredPaymentApp's React.lazy import); the checkout dependency
// tree is not SSR-safe. The reactivated renderer + the client entry already
// wrap the document in the Redux Provider, so no Provider is needed here.
registerCheckoutCascades(store);

type IProps = Immutable<{
    // The view's serialized init_data payload, sourced from the reactivated
    // document prop rather than the mount div's data-init-data attribute.
    initData: string;
}>;

// The ErrorBoundary lives in DeferredPaymentApp (wrapping Suspense) so it also
// catches chunk-load failures of this lazy module.
const DeferredPaymentAppInner = (props: IProps): React.JSX.Element => {
    const disableFreeShippingMessage = strToBool(
        String(
            getPageSetting("disable_basket_free_shipping_message") || "false",
        ),
    );
    return (
        <CompleteDeferredPayment
            initDataJSON={props.initData || ""}
            enableSplitPay={getPageSetting("enable_split_pay") || false}
            buildFinancingUpsell={(grandTotal) => {
                return <FinancingUpsellBlock grandTotal={grandTotal} />;
            }}
            disableFreeShippingMessage={disableFreeShippingMessage}
        />
    );
};

export default DeferredPaymentAppInner;
